import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET CENTER DCB REPORT START *********************** */
export const centerDCBReportListGet = (listData: any) => {
	const data = {
		CenterDCBReportListToken: listData,
	};
	const url = `${API_URL}centerDCBReport`;
	return makeApiCall(url, data);
};
/** ***************** GET CENTER DCB REPORT END ************************/
